import { BCAHeaderWithAPI, BCAFooter } from "@bca/ui-library";

import getEnvironment from "../helpers/getEnvironment";

const Layout = (props: {
  user?: { firstName: string; lastName: string };
  idToken?: string;
  children: any;
  hideFooter?: boolean;
  isToUseAuthZero: boolean;
  isAuthenticated: boolean;
  logoutUrl?: string;
}) => {
  const environment = getEnvironment();
  const isProd = environment === "production";
  const isUat = environment === "preview";

  const magnoliaRootUrl = isProd
    ? "https://www.bca.co.uk/"
    : isUat
      ? "https://cms.uat.britishcarauctions.net/"
      : "https://cmsmain-dev.bca.co.uk/";

  const onHandleLogout = () => {
    if (props.isToUseAuthZero && props.isAuthenticated && props.logoutUrl) {
      window.location.href = props.logoutUrl;
    }
  };

  return (
    <>
      <BCAHeaderWithAPI
        urls={{
          myBCALink: isProd
            ? "https://www.bca.co.uk/mybca/dashboard/"
            : "https://cms.uat.britishcarauctions.net/mybca/dashboard/",
          searchRootURL: magnoliaRootUrl,
          myBCAInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/MyBCA-Menu`,
          navLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Main-Menu`,
          // this is a required prop that is no longer needed/used
          login: "",
          logout: props.isToUseAuthZero
            ? null
            : process.env.isProd
              ? `https://login.bca.co.uk/connect/endsession?id_token_hint=${props.idToken}&post_logout_redirect_uri=https://www.bca.co.uk`
              : `https://login.uat.britishcarauctions.net/connect/endsession?id_token_hint=${props.idToken}&post_logout_redirect_uri=https://cms.uat.britishcarauctions.net`,
          vehicleOptions: isProd
            ? "https://auctionview.bca.co.uk/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en"
            : "https://auctionview.uat.britishcarauctions.net/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en",
          auctionViewRoot: isProd
            ? "https://auctionview.bca.co.uk/"
            : "https://auctionview.uat.britishcarauctions.net/",
          trackedLink: isProd
            ? "https://www.bca.co.uk/search?requestOrigin=Tracked"
            : "https://cms.uat.britishcarauctions.net/search?requestOrigin=Tracked",
        }}
        user={props?.user}
        onSignOutClick={onHandleLogout}
      />
      <div style={{ minHeight: "100vh" }}>{props.children}</div>
      {!props.hideFooter && (
        <BCAFooter
          urls={{
            navigationLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer`,
            legalInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer-Legal`,
            socialMedia: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Social-Links`,
          }}
        ></BCAFooter>
      )}
    </>
  );
};

export default Layout;
